var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.$t("travelService.orderParameters")) + ":")]),
    _c(
      "div",
      { staticStyle: { "font-size": "larger" } },
      [
        _c(
          "v-row",
          { attrs: { "no-gutters": "" } },
          [
            _vm.type === "flight" || _vm.type === "low-cost"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.startLocationText,
                          filled: "",
                          label: _vm.$t("travelService.departureAirport"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.endLocationText,
                          filled: "",
                          label: _vm.$t("travelService.arrivalAirport"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.is_baggage === 1
                              ? _vm.$t("global.required")
                              : _vm.$t("global.notRequired"),
                          filled: "",
                          label: _vm.$t("travelService.registeredBaggage")
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.start_date +
                            ", " +
                            _vm.getHourText(_vm.orderItem.start_time),
                          filled: "",
                          label: _vm.$t("travelService.startDateAndHour"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.return_date != null
                              ? _vm.orderItem.return_date +
                                ", " +
                                _vm.getHourText(_vm.orderItem.return_time)
                              : _vm.$t("travelService.oneWayTravel"),
                          filled: "",
                          label: _vm.$t("travelService.returnDateAndHour"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.allFlightClassTypes.find(function(v) {
                            return v.value === _vm.orderItem.seat_class
                          }).text,
                          filled: "",
                          label: _vm.$t("travelService.class"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm.orderItem.additionalSegments.length > 0
                    ? _c("v-col", { attrs: { cols: "12" } }, [
                        _c(
                          "fieldset",
                          { staticClass: "custom-fieldset" },
                          [
                            _c("legend", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("travelService.additionalSegments")
                                )
                              )
                            ]),
                            _vm._l(_vm.orderItem.additionalSegments, function(
                              segment,
                              index
                            ) {
                              return _c(
                                "v-row",
                                { key: index },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "px-2",
                                      attrs: { md: "4", cols: "12" }
                                    },
                                    [
                                      _c("location-ajax-select", {
                                        attrs: {
                                          readonly: true,
                                          label: _vm.$t(
                                            "travelService.departureAirport"
                                          ),
                                          "select-model":
                                            segment.start_place_id,
                                          box: true
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "px-2",
                                      attrs: { md: "4", cols: "12" }
                                    },
                                    [
                                      _c("location-ajax-select", {
                                        attrs: {
                                          readonly: true,
                                          label: _vm.$t(
                                            "travelService.arrivalAirport"
                                          ),
                                          "select-model": segment.end_place_id,
                                          box: true
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "px-2",
                                      attrs: { md: "4", cols: "12" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          value:
                                            segment.start_date +
                                            ", " +
                                            _vm.getHourText(segment.start_time),
                                          filled: "",
                                          label: _vm.$t(
                                            "travelService.startDateAndHour"
                                          ),
                                          readonly: ""
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ])
                    : _vm._e(),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.is_priority_boarding === 1
                              ? _vm.$t("global.required")
                              : _vm.$t("global.notRequired"),
                          filled: "",
                          label: "Priority boarding/Fast track",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.preferred_seat,
                          filled: "",
                          label: _vm.$t("travelService.preferredSeat"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm.orderItem.is_additional_services
                    ? _c(
                        "v-col",
                        { staticClass: "px-2", attrs: { md: "8", cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.orderItem.additional_services,
                              filled: "",
                              label: _vm.$t(
                                "travelService.additionalServicesDetails"
                              ),
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm.type === "car"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.startLocationText,
                          filled: "",
                          label: _vm.$t("travelService.pickupPlace"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.endLocationText != null
                              ? _vm.orderItem.endLocationText
                              : _vm.$t("travelService.theSameAsPickup"),
                          filled: "",
                          label: _vm.$t("travelService.returnCarPlace"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.allCarTypes.find(function(v) {
                              return v.value === _vm.orderItem.car_class
                            }) != null
                              ? _vm.allCarTypes.find(function(v) {
                                  return v.value === _vm.orderItem.car_class
                                }).text
                              : null,
                          filled: "",
                          label: _vm.$t("travelService.carClass"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.start_date +
                            ", " +
                            _vm.getHourText(_vm.orderItem.start_time),
                          filled: "",
                          label: _vm.$t(
                            "travelService.pickupDateAndPreferredHour"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.end_date != null
                              ? _vm.orderItem.end_date +
                                ", " +
                                _vm.getHourText(_vm.orderItem.end_time)
                              : "",
                          filled: "",
                          label: _vm.$t(
                            "travelService.returnDateAndPreferredTime"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.type === "rail"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.startLocationText,
                          filled: "",
                          label: _vm.$t("travelService.departureRailPlace"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.endLocationText,
                          filled: "",
                          label: _vm.$t("travelService.arrivalRailPlace"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.allRailClassTypes.find(function(v) {
                            return v.value === _vm.orderItem.seat_class
                          }).text,
                          filled: "",
                          label: _vm.$t("travelService.class"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.start_date +
                            ", " +
                            _vm.getHourText(_vm.orderItem.start_time),
                          filled: "",
                          label: _vm.$t(
                            "travelService.departureRailDateAndPreferredTime"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.return_date != null
                              ? _vm.orderItem.return_date +
                                ", " +
                                _vm.getHourText(_vm.orderItem.return_time)
                              : "Podróż w jedną stronę",
                          filled: "",
                          label: _vm.$t(
                            "travelService.returnRailDateAndPreferredTime"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.type === "hotel"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.locationText,
                          filled: "",
                          label: _vm.$t("travelService.preferredHotelPlace"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.allRoomTypes.find(function(v) {
                              return v.value === _vm.orderItem.room_type
                            }) != null
                              ? _vm.allRoomTypes.find(function(v) {
                                  return v.value === _vm.orderItem.room_type
                                }).text
                              : null,
                          filled: "",
                          label: _vm.$t("travelService.roomType"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.parking_required === 1
                              ? _vm.$t("global.required")
                              : _vm.$t("global.notRequired"),
                          filled: "",
                          label: "Parking",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.start_date +
                            ", " +
                            _vm.getHourText(_vm.orderItem.start_time),
                          filled: "",
                          label: _vm.$t(
                            "travelService.accommodationDateAndPreferredTime"
                          ),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.end_date,
                          filled: "",
                          label: _vm.$t("travelService.outDate"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.is_breakfast
                            ? _vm.$t("global.required")
                            : _vm.$t("global.notRequired"),
                          filled: "",
                          label: _vm.$t("global.breakfast"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.is_free_cancellation
                            ? _vm.$t("global.required")
                            : _vm.$t("global.notRequired"),
                          filled: "",
                          label: _vm.$t("travelService.freeCancel"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.orderItem.currency == null
                              ? _vm.$t("global.standard")
                              : _vm.orderItem.currency,
                          filled: "",
                          label: _vm.$t("travelService.preferredCurrency"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm.orderItem.is_additional_services
                    ? _c(
                        "v-col",
                        { staticClass: "px-2", attrs: { md: "8", cols: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              value: _vm.orderItem.additional_services,
                              filled: "",
                              label: _vm.$t("travelService.additionalServices"),
                              readonly: ""
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              : _vm._e(),
            _vm.type === "insurance"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.$t("travelService.types.insurance"),
                          filled: "",
                          label: _vm.$t("booking.other.serviceName"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.locationText,
                          filled: "",
                          label: _vm.$t("global.place"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value:
                            _vm.$t("global.fromDateShort") +
                            " " +
                            _vm.orderItem.start_date +
                            " " +
                            _vm.$t("global.toDateShort") +
                            " " +
                            _vm.orderItem.end_date,
                          filled: "",
                          label: _vm.$t("travelService.insuranceDates"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            _vm.type === "other"
              ? [
                  _c(
                    "v-col",
                    { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          value: _vm.orderItem.name,
                          filled: "",
                          label: _vm.$t("booking.other.serviceName"),
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ]
              : _vm._e(),
            !!_vm.orderItem.cost_centre
              ? _c(
                  "v-col",
                  { staticClass: "px-2", attrs: { md: "4", cols: "12" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        value: _vm.orderItem.cost_centre,
                        filled: "",
                        label: _vm.$t("global.costCentre"),
                        readonly: ""
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        ),
        _c("admin-passengers-data-preview", {
          attrs: { users: _vm.orderItem.users }
        }),
        _c("admin-travel-service-additional-params-preview", {
          attrs: { "additional-parameters": _vm.orderItem }
        }),
        _vm.orderItem.comment != null && _vm.orderItem.comment.length > 0
          ? _c(
              "v-col",
              { staticClass: "px-2", attrs: { cols: "12" } },
              [
                _c("v-textarea", {
                  attrs: {
                    value: _vm.orderItem.comment,
                    filled: "",
                    label: _vm.$t("global.comment"),
                    "auto-grow": "",
                    rows: 1,
                    readonly: "",
                    outlined: ""
                  }
                })
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }